export default __webpack_public_path__ + "static/media/Contact-hero.5c1b02d0.png";